import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Countdown from "react-countdown";
import ReactCodeInput from "react-code-input";
import { Navigate } from "react-router-dom";
import SMS from "../../../assets/resend-sms.svg";
import LoadingComponent from "../../LoadingComponent";
import { fireGtagEvent } from "../../../utils/google-analytics";
import { ErrorTemplate } from "../../../templates";
import { resetUserStore, setToken, setUserDetails } from "../../../store";
import { useLoginUserMutation, useReSendOtpMutation } from "../../../hooks";

export default function OtpTemplate() {
  const dispatch = useDispatch();
  const OTP_DEFAULT_TIME = 30;
  const user = useSelector((state) => state.user);
  const {
    mutate: loginUser,
    status: loginStatus,
    error: loginError
  } = useLoginUserMutation();
  const { mutate: resendOtpMutation, status: resendStatus } =
    useReSendOtpMutation(user);
  const [timer, setTimer] = useState(OTP_DEFAULT_TIME);
  const [key, setKey] = useState(1);
  const [date, setDate] = useState(Date.now() + timer * 1000);
  const [otp, setOtp] = useState();

  useEffect(() => {
    if (timer) {
      setKey((prev) => prev + 1);
      setDate(Date.now() + timer * 1000);
    }
  }, [timer]);

  const countdownRenderer = ({ minutes, seconds }) => {
    if (timer) {
      const paddedMinutes = String(minutes).padStart(2, "0");
      const paddedSeconds = String(seconds).padStart(2, "0");

      return (
        <span>
          {paddedMinutes}:{paddedSeconds}
        </span>
      );
    }

    return null;
  };

  const validateOTP = () => {
    fireGtagEvent("otp_entered");
    loginUser(otp, {
      onSuccess: (data) => {
        dispatch(setToken(data.token));
        dispatch(setUserDetails(data.user));
      }
    });
  };

  const handleResendOtp = () => {
    resendOtpMutation();
    setTimer(OTP_DEFAULT_TIME);
  };

  const handleChangeNumber = () => {
    dispatch(resetUserStore());
    return <Navigate to="/login" />;
  };

  return (
    <div className="otp-validation">
      <h2>Verify +91-{user.details.phoneNumber} </h2>
      <h3>
        Please enter the OTP sent to {user.details.phoneNumber}{" "}
        <button type="button" id="resend pointer" onClick={handleChangeNumber}>
          Change number?
        </button>
      </h3>
      <div className="otp-section">
        <ReactCodeInput
          type="number"
          fields={6}
          value={otp}
          onChange={setOtp}
        />
        {loginStatus === "error" && (
          <ErrorTemplate error={loginError?.message} />
        )}
        <h2 className="otp-section-heading">Enter 6-digit Code</h2>
        <div className="resend-otp">
          <img src={SMS} alt="" />
          {resendStatus === "pending" ? (
            <h3>sending...</h3>
          ) : (
            <button
              type="button"
              id="resend-sms"
              onClick={handleResendOtp}
              disabled={!!timer}
            >
              Resend SMS
            </button>
          )}
          <h3>
            <Countdown
              date={date}
              renderer={countdownRenderer}
              key={key}
              onComplete={() => setTimer(0)}
            />
          </h3>
        </div>
      </div>
      {loginStatus === "pending" ? (
        <button type="button" id="otp-validation-btn" aria-label="Loading">
          <LoadingComponent diameter="30" color="#ffffff" />
        </button>
      ) : (
        <button type="button" id="otp-validation-btn" onClick={validateOTP}>
          Verify
        </button>
      )}
    </div>
  );
}
